import { Component, Injectable, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDateParserFormatter, NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomFieldService } from 'api-services/custom-field.service';
import { EntityType } from 'models/custom-fields/entity-type.enum';
import { Field } from 'models/custom-fields/field.model';
import { GetField } from 'models/custom-fields/get-field.model';
import { SaveFieldValue } from 'models/custom-fields/save-field-value.model';
import { RoleService } from 'services/role.service';
import { ContactDashboardStoreProcedure } from 'shared/constant';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.month + this.DELIMITER + date.day + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  selector: 'app-custom-field-information',
  templateUrl: './custom-field-information.component.html',
  styleUrls: ['./custom-field-information.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ]
})
export class CustomFieldInformationComponent implements OnInit {

  @Input() entityId: number;
  @Input() entityType: number;

  activeList: boolean = false;
  isAdminUser = false;
  isTenantOwnerUser = false;
  isContactUser = false;
  isMGAUser = false;

  customFieldList = [] as Field[];
  EntityType = EntityType;

  selectedDate!: NgbDateStruct;
  selectedTime!: NgbTimeStruct;
  combinedDate: Date = new Date();

  constructor(private roleService: RoleService, private customFieldService: CustomFieldService,private router: Router,) { }

  ngOnInit(): void {
    
    this.isAdminUser = this.roleService.isAdminUser;
    this.isTenantOwnerUser = this.roleService.isTenantOwnerUser;
     this.isContactUser = this.roleService.isContactUser;
    this.isMGAUser = this.roleService.isMGAUser;

    this.getCustomFields();
  }

  getCustomFields() {
    var getFieldRequest = {
      entityId: this.entityId,
      entityType: this.entityType
    } as GetField;
    this.customFieldService.getFields(getFieldRequest).subscribe
      ((res) => {
        this.customFieldList = res;
        this.activeList = true;
        this.customFieldList.forEach(field => {
          field.isEditable = false;
          field.previousValue = field.value;

          if (field.fieldType === 'Date' && field.value) {            
            const date = new Date(field.value);
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const yyyy = date.getFullYear();
            const formattedDate = `${mm}/${dd}/${yyyy}`;

            field.displayValue = formattedDate;
            field.value = <NgbDateStruct>{
              year: date.getFullYear(),
              month: date.getMonth() + 1,
              day: date.getDate()
            };
          }
        });
      }, err => {
        this.activeList = true;
      });
    }

  preventLeadingSpace(value) {
    value = value.trimStart();
  }

  clearValue(field){
    field.isEditable = false;
    field.value =  field.previousValue;
  }

  editCustomField(field){
    field.isEditable = true;
    if(field.fieldType == 'DateTime' && field.value != null){
      this.getselectedDateTime(field.value);
    }
  }

  // datetime
  getselectedDateTime(value){  
    if(value){    
      this.selectedDate = {
        year: Number(value.split('/')[2].split(' ')[0]),
        month: Number(value.split('/')[0]),
        day: Number(value.split('/')[1])
      };

      this.selectedTime = {
        hour: Number(value.split('/')[2].split(' ')[1].split(':')[0]),
        minute: Number(value.split('/')[2].split(' ')[1].split(':')[1]),
        second: 0
      };
    }   
  }

  saveField(field: Field): void {
  
    let value = field.value.toString();  
    if (field.fieldType === 'Date' && field.value) {  
      const d = field.value as NgbDateStruct;
      value = `${d.year}/${('0' + d.month).slice(-2)}/${('0' + d.day).slice(-2)}`;
    }

    if (field.fieldType === 'DateTime') {  
      value = this.formatDateTime();
      field.value = value;  
    }

    let _request = {  
      fieldId: field.fieldId,  
      entityType: this.entityType,  
      entityId: this.entityId,
      value: value  
    } as SaveFieldValue;

    this.customFieldService.saveFieldValue(_request).subscribe(() => {
      if (field.fieldType === 'Date' && field.value) {
        const d = field.value as NgbDateStruct;
        const formattedDate = `${('0' + d.month).slice(-2)}/${('0' + d.day).slice(-2)}/${d.year}`;
        field.displayValue = formattedDate;
      }          
      field.previousValue = field.value;
      field.isEditable = false;  
    });  
  }

  onDateTimeChange() {
    if (this.selectedDate && this.selectedTime) {
      this.combinedDate = new Date(
        this.selectedDate.year,
        this.selectedDate.month - 1,
        this.selectedDate.day,
        this.selectedTime.hour,
        this.selectedTime.minute,
        0
      );
    }
  }

  formatDateTime(): string {
    if (!this.selectedDate || !this.selectedTime) return '';
      const pad = (num: number) => String(num).padStart(2, '0');
      const dateStr = `${pad(this.selectedDate.month)}/${pad(this.selectedDate.day)}/${this.selectedDate.year}`;
      const timeStr = `${pad(this.selectedTime.hour)}:${pad(this.selectedTime.minute)}`;
    return `${dateStr} ${timeStr} ${this.selectedTime.hour >= 12 ? 'PM' : 'AM'}`;
  }

  manageCustomFields(){
    localStorage.setItem('fields', "manage-custom-fields"+","+this.entityType);

    if(this.isMGAUser){
      this.router.navigate(['/settings'],  { queryParams: { query: 'manage-mga' }} );
    }else{
      this.router.navigate(['/settings'],  { queryParams: { query: 'manage-carriers' }} );
    }
  }

}
